import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core'

import { pick as _pick } from 'lodash/fp'

import { FlxUserInitialsPipe } from '@flowx/designer/pipes/user-initials.pipe'
import { FlxStatusComponent } from '@flowx/designer/shared/components/status/status.component'

import { AccessManagementUser, RUNTIME_USER_STATUS_CONFIG } from '../../workspace.utils'

@Component({
  selector: 'flx-user-summary',
  imports: [FlxStatusComponent, FlxUserInitialsPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './user-summary.component.html',
})
export class FlxUserSummaryComponent {
  user = input.required<AccessManagementUser>()
  userForDisplay = computed(() => {
    const user = this.user()
    return {
      ..._pick(['firstName', 'lastName', 'email'], user),
      userName: user.firstName + user.lastName,
      status: RUNTIME_USER_STATUS_CONFIG[user.status],
    }
  })
}
